import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AppConfigurationService {

    public baseApi   : string;
    public appVersion: string;
    public paymentApi: string;

    constructor() {

        this.baseApi    = environment.baseApi;
        this.appVersion = environment.version;
        this.paymentApi = environment.paymentApi;

    }

}
